/**
 * Texto pré-preenchido ao abrir /indique no WhatsApp.
 * Deve ser idêntico ao array em `public/index.html` (função indiqueWhatsappRedirect).
 */
const LINES = [
  'Oi!',
  '',
  'Eu já usei a Consulta+ (consulta médica online por chat, sem videochamada — o médico pode emitir receita e atestado digital quando faz sentido para o caso) e quis te passar o contato.',
  '',
  'App oficial pra baixar: https://consultamais.app/baixar',
  '',
  'Dúvidas comuns e privacidade: https://consultamais.app/ (site) e https://consultamais.app/lgpd',
  '',
  'Qualquer coisa me chama!',
];

export const INDICA_WHATSAPP_TEXT = LINES.join('\n');

export function buildIndiqueWaUrl() {
  return `https://wa.me/?text=${encodeURIComponent(INDICA_WHATSAPP_TEXT)}`;
}
